/**
 * Domain registry types. Domains are user-managed labels for grouping and
 * filtering tasks. Forward path: domains will also drive AI handler routing,
 * default profile, default allowlist, and default guardrails.
 */
import { z } from 'zod';

const SLUG_REGEX = /^[a-z][a-z0-9_-]*$/;

export const DomainSchema = z.object({
  slug: z.string().regex(SLUG_REGEX, 'Use lowercase letters, digits, hyphens, or underscores'),
  name: z.string().min(1).max(80),
  description: z.string().default(''),
  built_in: z.boolean().default(false),
});
export type Domain = z.infer<typeof DomainSchema>;

export const DomainCreateSchema = DomainSchema.omit({ built_in: true });
export type DomainCreate = z.infer<typeof DomainCreateSchema>;

export const DomainEditSchema = z.object({
  name: z.string().min(1).max(80).optional(),
  description: z.string().optional(),
});
export type DomainEdit = z.infer<typeof DomainEditSchema>;

/** The slug seeded by `pnpm db:seed` for first-time setups. */
export const DEFAULT_DOMAIN_SLUG = 'default';

export const BUILT_IN_DOMAINS: Domain[] = [
  {
    slug: DEFAULT_DOMAIN_SLUG,
    name: 'Default',
    description: 'Catch-all domain used when nothing more specific applies.',
    built_in: true,
  },
];
